import { useTranslation } from 'react-i18next';

const MARKETING_SITE_LOCALES = [
  {
    languageCode: 'en',
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms',
  },
  {
    languageCode: 'es',
    marketingSiteDomain: 'mx.c2fo.com',
    terms: '/terms',
  },
  {
    languageCode: 'fr',
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms-conditions-french',
  },
  {
    languageCode: 'it',
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms-conditions-italian',
  },
  {
    languageCode: 'de',
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms-conditions-german',
  },
  {
    languageCode: 'nl',
    // No marketing site for Dutch
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms-conditions-dutch',
  },
  {
    languageCode: 'pt-BR',
    // No marketing site for Portuguese
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms-conditions-portuguese',
  },
  {
    languageCode: 'ru',
    // No marketing site for Russian
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms-conditions-russian',
  },
  {
    languageCode: 'tr',
    // No marketing site for Turkish
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms-conditions-turkish',
  },
  {
    languageCode: 'ja',
    // No marketing site for Japanese
    marketingSiteDomain: 'c2fo.com',
    terms: '/terms-conditions-japanese',
  },
  {
    languageCode: 'zh-CN',
    marketingSiteDomain: 'chn.c2fo.com',
    terms: '/terms',
  },
  {
    languageCode: 'zh-TW',
    marketingSiteDomain: 'tw.c2fo.com',
    terms: '/terms-conditions',
  },
];

export const useAgreementsUrl = () => {
  const { i18n } = useTranslation();

  const { marketingSiteDomain, terms } =
    MARKETING_SITE_LOCALES.find((l) => l.languageCode === i18n.language) ?? MARKETING_SITE_LOCALES[0];

  // All users will be directed to the English privacy policy link
  // if a user wants to view the privacy policy in a different language, they can switch the language in the c2fo.com site
  const privacyLink = 'https://c2fo.com/privacy-policy';
  const termsOfUseLink = `https://${marketingSiteDomain.concat(terms)}`;

  return {
    privacyLink,
    termsOfUseLink,
  };
};
